const getCustomerIO = () => {
  return (window as any)?._cio;
};

export default getCustomerIO;
